import { TaxRetentions } from "components";

export function RetentionsInProcess() {
  return (
    <div>
      <h1 style={{ fontSize: "1.5rem" }}>Retenciones Emitidas en proceso</h1>

      <TaxRetentions showPeriodicity itemsPerPage={10} defaultStatus="PENDING" />
    </div>
  );
}
